import { render } from "./QuickPost.vue.js?vue&type=template&id=23eb0c48!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./QuickPost.vue?vue&type=template&id=23eb0c48"
import script from "./QuickPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./QuickPost.vue?vue&type=script&lang=js"
export * from "./QuickPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./QuickPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/components/QuickPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23eb0c48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23eb0c48', __exports__)) {
    api.reload('23eb0c48', __exports__)
  }
  
  module.hot.accept("./QuickPost.vue.js?vue&type=template&id=23eb0c48!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./QuickPost.vue?vue&type=template&id=23eb0c48", () => {
    api.rerender('23eb0c48', render)
  })

}


export default __exports__